export default class CloseCustomerUnlinkModal {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.modal.remove();
  }
}
